import { SearchablePublicationSheetInstantSearch } from '@livv/models';
import { completePreviewLink, getSheetLink } from '@livv/utils/helpers';
import { Hit } from 'instantsearch.js';
import { FC } from 'react';
import ContentCard, { PreviewCardProps } from './ContentCard';
import NotesSnippet, { SnippetWithNotes } from './NotesSnippet';
import { APP_URL } from '@utils/consts/livv';
import { getFullTextSearchQuery } from '@utils/search/snippet';

interface PublicationSheetPreviewProps
    extends PreviewCardProps<SearchablePublicationSheetInstantSearch> {
    query: string;
}

const PublicationSheetPreview: FC<PublicationSheetPreviewProps> = ({ hit, query }) => {
    const { baseObjectID, path, treeId } = hit;
    const baseHref = getSheetLink({
        bookId: treeId,
        bookPath: path.join('/'),
        sheetId: baseObjectID,
    });

    return (
        <ContentCard
            hit={hit}
            href={completePreviewLink(baseHref, APP_URL, getFullTextSearchQuery(hit, query))}
            snippetAttribute="fullText"
            subtitleAttributes={[{ attribute: 'subtitle' }]}
            titleAttribute="title"
        >
            <NotesSnippet
                hit={hit as Hit<SearchablePublicationSheetInstantSearch> & SnippetWithNotes}
            />
        </ContentCard>
    );
};

export default PublicationSheetPreview;
